import React, { useEffect, useState } from "react";
import api, { url } from "../../utilis/api";
import { toast } from "react-toastify";

const Modal = ({ children, onClose, title }) => {
  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[420px] rounded-xl bg-[#0f172a] border border-gray-700 shadow-xl p-5 text-white"
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-red-400 text-xl"
          >
            ✕
          </button>
        </div>

        {children}
      </div>
    </div>
  );
};

const Vendors = () => {
  const [vendors, setVendors] = useState([]);

  const [createModal, setCreateModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [selectedVendor, setSelectedVendor] = useState(null);

  const [form, setForm] = useState({
    name: "",
    status: "Enable",
    image: null,
  });

  // ================= FETCH =================
  const fetchVendors = async () => {
    const res = await api.get("/brands");
    setVendors(res.data.data || []);
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  // ================= INPUT HANDLER =================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFile = (e) => {
    setForm({ ...form, image: e.target.files[0] });
  };

  // ================= CREATE =================
  const handleCreate = async () => {
    try {
      const formData = new FormData();

      formData.append("name", form.name);
      formData.append("status", form.status);
      formData.append("image", form.image);

      // DEBUG
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      await api.post("/brands", formData);
      toast.success("Brand created successfully 🚀");
      setCreateModal(false);

      setForm({
        name: "",
        status: "Enable",
        image: null,
      });

      fetchVendors();
    } catch (error) {
      console.log("CREATE ERROR:", error);
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    try {
      await api.delete(`/brands/${id}`);

      toast.success("Brand deleted successfully 🗑️");

      fetchVendors();
    } catch (error) {
      console.log(error);
      toast.error("Failed to delete brand ❌");
    }
  };
  // ================= UPDATE =================
  const handleUpdate = async () => {
    try {
      const formData = new FormData();

      formData.append("name", form.name);
      formData.append("status", form.status);

      if (form.image) {
        formData.append("image", form.image);
      }

      await api.put(`/brands/${selectedVendor._id}`, formData);

      toast.success("Brand updated successfully ✨");

      setEditModal(false);
      fetchVendors();
    } catch (error) {
      console.log(error);
      toast.error("Failed to update brand ❌");
    }
  };
  // ================= UI =================
  return (
    <div className="min-h-screen bg-[#0b1220] text-white p-6">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Vendors</h2>

        <button
          onClick={() => setCreateModal(true)}
          className="bg-blue-600 hover:bg-blue-700 px-5 py-2 rounded-lg shadow"
        >
          + Create Vendor
        </button>
      </div>

      {/* TABLE CARD */}
      <div className="bg-[#111827] border border-gray-800 rounded-xl overflow-hidden shadow-lg">
        <table className="w-full text-sm">
          <thead className="bg-[#0f172a] text-gray-300">
            <tr>
              <th className="p-3 text-left">Image</th>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {vendors.map((v) => (
              <tr
                key={v._id}
                className="border-t border-gray-800 hover:bg-[#0f172a] transition"
              >
                {/* IMAGE */}
                <td className="p-3">
                  <img
                    src={`${url}${v.image}`}
                    className="w-30 h-20 rounded-[12px] object-cover border border-gray-700"
                  />
                </td>

                {/* NAME */}
                <td className="p-3 font-medium">{v.name}</td>

                {/* STATUS */}
                <td className="p-3">
                  <span
                    className={`px-3 py-1 text-xs rounded-full font-semibold
                      ${
                        v.status === "Enable"
                          ? "bg-green-500/20 text-green-400"
                          : "bg-red-500/20 text-red-400"
                      }`}
                  >
                    {v.status}
                  </span>
                </td>

                {/* ACTIONS */}
                <td className="p-3 text-center space-x-2">
                  <button
                    onClick={() => {
                      setSelectedVendor(v);
                      setViewModal(true);
                    }}
                    className="px-3 py-1 bg-green-600 hover:bg-green-700 rounded-md"
                  >
                    View
                  </button>

                  <button
                    onClick={() => {
                      setSelectedVendor(v);
                      setForm(v);
                      setEditModal(true);
                    }}
                    className="px-3 py-1 bg-yellow-500 hover:bg-yellow-600 rounded-md text-black"
                  >
                    Edit
                  </button>

                  <button
                    onClick={() => handleDelete(v._id)}
                    className="px-3 py-1 bg-red-600 hover:bg-red-700 rounded-md"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= CREATE MODAL ================= */}
      {createModal && (
        <Modal onClose={() => setCreateModal(false)} title="Create Vendor">
          <input
            name="name"
            placeholder="Vendor Name"
            onChange={handleChange}
            className="w-full mb-3 p-2 rounded bg-[#0b1220] border border-gray-700 text-white"
          />

          <select
            name="status"
            onChange={handleChange}
            className="w-full mb-3 p-2 rounded bg-[#0b1220] border border-gray-700 text-white"
          >
            <option>Enable</option>
            <option>Disable</option>
          </select>

          <input type="file" onChange={handleFile} className="mb-4" />

          <button
            onClick={handleCreate}
            className="w-full bg-blue-600 hover:bg-blue-700 py-2 rounded"
          >
            Save Vendor
          </button>
        </Modal>
      )}

      {/* ================= VIEW MODAL ================= */}
      {viewModal && selectedVendor && (
        <Modal onClose={() => setViewModal(false)} title="Vendor Details">
          <div className="text-center">
            <img
              src={`/${selectedVendor.image}`}
              className="w-24 h-24 mx-auto rounded-full border border-gray-700 mb-3"
            />

            <h3 className="text-lg font-semibold">{selectedVendor.name}</h3>

            <p className="mt-2 text-gray-300">
              Status: {selectedVendor.status}
            </p>
          </div>
        </Modal>
      )}

      {/* ================= EDIT MODAL ================= */}
      {editModal && selectedVendor && (
        <Modal onClose={() => setEditModal(false)} title="Edit Vendor">
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full mb-3 p-2 rounded bg-[#0b1220] border border-gray-700 text-white"
          />

          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            className="w-full mb-3 p-2 rounded bg-[#0b1220] border border-gray-700 text-white"
          >
            <option>Enable</option>
            <option>Disable</option>
          </select>

          <input type="file" onChange={handleFile} className="mb-4" />

          <button
            onClick={handleUpdate}
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-2 rounded"
          >
            Update Vendor
          </button>
        </Modal>
      )}
    </div>
  );
};

export default Vendors;
